import {
  ConfigType,
  ContentSectionContextProps,
  ContentSectionItem,
  GenericConfig,
  PossibleContentSections,
} from './fragment-and-types';

export const extractGenericConfig = <T extends PossibleContentSections>(
  configs: GenericConfig[],
  section: ContentSectionItem<T>,
): ConfigType<T> | undefined => {
  const extractor = configs.find((extract) =>
    extract((config) => config.isComponent(section)),
  );

  if (extractor) {
    let config;
    extractor((e) => {
      config = e;
    });
    return config;
  }

  return undefined;
};

export const selectComponent = <T extends PossibleContentSections>(
  section: ContentSectionItem<T>,
  index: number,
  context: ContentSectionContextProps,
  possibleComponents: GenericConfig[],
): React.ReactElement<T> | null => {
  const config = extractGenericConfig(possibleComponents, section);

  if (config && config.isComponent(section)) {
    const { Component } = config;
    return (
      <Component
        key={index}
        {...(section as ContentSectionItem<T>)}
        {...context}
        componentIndex={index}
      />
    );
  }

  return null;
};
